import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import ProjectLinks from "./ProjectLinks";
import SaveIcon from "../../assets/icons/save.svg2";
import HelpButton from "../HelpContent/HelpButton";

export default function Project() {
  const [projectData, setProjectData] = useState({
    Label: "Customer Service Comms",
    UUID: "afsgeretwb",
    Reference: "Project 1",
    Components: [],
  });

  return (
    <div className="">
      <div className="bg-loop position-relative row mx-0 mb-3 align-items-center rounded-3">
        <span className="position-absolute top-0 start-50 translate-middle rounded-pill text-white py-1 px-4 text-spaced fw-bold w-auto bg-colored text-xs">
          PROJECT
        </span>
        <div className="col-3 p-4">
          <h1 className="fw-bold">
            Free Build{" "}
            <HelpButton helpKey="create-boomlogic-project-overview" />
          </h1>
          <span className="text-secondary">boomLogic Project Builder</span>
        </div>
        <div className="col-6 p-4 pb-0 mb-n1">
          <h3 className="fw-bold text-center text-break">
            "{projectData.Label}"
          </h3>
          <div className="m-auto d-flex justify-content-center gap-3">
            <div className="text-secondary text-nowrap">
              <span className="fw-bold fs-5 me-1">Boomerang ref:</span>
              {projectData.UUID}
            </div>
            <div className="text-secondary text-break">
              <span className="fw-bold fs-5 me-1">Your ref:</span>
              {projectData.Reference}
            </div>
          </div>
          <ProjectLinks />
        </div>
        <div className="col-3 p-4  text-end">
          <button
            type="button"
            className="btn rounded-pill bg-icon px-1 p-2 fw-bold"
          >
            <span className="p-2  bg-white rounded-pill me-2">
              <SaveIcon width="1rem" height="1rem" />
            </span>
            Save progress
          </button>
        </div>
      </div>
      <Outlet context={[projectData, setProjectData]} />
    </div>
  );
}
